import '../styles/Services.css';
import { TargetService } from './ui/TargetService.jsx';

export function Services(){
  return(
    <section id="services" className="services">
      <h3 className="title">Servicios de consultoría</h3>
      <p className="services-intro">
        Acompaño a instituciones públicas y empresas privadas en cada etapa: desde el diagnóstico hasta la implantación, la capacitación y el soporte.
      </p>

      <div className="services-content">

        <TargetService
          title="Diagnóstico y hoja de ruta digital"
          text="Analizo tus procesos y sistemas actuales, priorizo qué digitalizar primero y formulo el proyecto tecnológico para ejecutarlo."
        />

        <TargetService
          title="Sistemas de información a medida"
          text="Diseño e implemento plataformas web y móviles para digitalizar trámites, recaudación, reservas o atención al cliente, sobre bases de datos SQL Server y MySQL."
        />

        <TargetService
          title="Modernización de sistemas heredados"
          text="Migro sistemas antiguos a una arquitectura moderna sin detener tu operación: mitigo riesgos, asumo el soporte y mejoro la seguridad con autenticación centralizada."
        />

        <TargetService
          title="Automatización y DevOps"
          text="Implemento pipelines CI/CD con GitLab y Jenkins y despliegues automáticos para que tu equipo entregue más rápido, con menos errores y menos carga operativa."
        />

        <TargetService
          title="Integración de sistemas y datos geoespaciales"
          text="Conecto tus sistemas mediante APIs y construyo SIG con PyQGIS y Mapbox para visualizar y analizar información territorial y operativa."
        />

        <TargetService
          title="Gobierno de TI, seguridad y capacitación"
          text="Aplico ITIL 4, COBIT e ISO 27001, documento cada sistema y capacito a tu equipo para que pueda operarlo sin depender de mí."
        />

      </div>
    </section>
  );
}
